import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

interface MarkAsProblemPickModalProps {
  isOpen: boolean;
  numSelectedGroups: number;
  onClose: () => void;
  onConfirm: () => void;
}

export const MarkAsProblemPickModal = memo(function MarkAsProblemPickModal({
  isOpen,
  numSelectedGroups,
  onClose,
  onConfirm,
}: MarkAsProblemPickModalProps) {
  return (
    <RedoModal
      isOpen={isOpen}
      onModalCloseRequested={onClose}
      primaryButton={{
        text: "Mark as problem",
        onClick: onConfirm,
        theme: "destructive",
      }}
      secondaryButton={{ text: "Cancel", onClick: onClose }}
      title="Mark as problem pick"
    >
      <Flex dir="column" gap="lg" p="lg">
        <Text fontSize="sm" textColor="secondary">
          Are you sure you want to mark{" "}
          {numSelectedGroups === 1
            ? "this order"
            : `these ${numSelectedGroups} orders`}{" "}
          as a problem pick?
        </Text>
        <Text fontSize="sm" textColor="secondary">
          This will create a problem pick session for any orders not currently
          in a pick session, allowing them to be tracked for resolution.
        </Text>
      </Flex>
    </RedoModal>
  );
});
